export default __webpack_public_path__ + "static/media/switch-spacing.7476d736.svg";